module.exports.roles = {
  vi: {
    title: 'Vai trò Avalon: Merlin, Percival, Morgana và nhiều vai khác',
    description:
      'Khám phá vai trò, năng lực và phe trong Avalon. Tìm hiểu Merlin, Percival thấy ai, các vai Ác hoạt động thế nào và nên thêm nhân vật nào vào ván chơi.',
    keywords: ['Vai trò', 'Luật chơi', 'Merlin', 'Percival', 'Morgana', 'Oberon', 'Mordred', 'Mẹo chơi'],
  },
  pt: {
    title: 'Avalon: The Resistance | Papéis',
    description:
      "Todos os papéis disponíveis no jogo de tabuleiro 'Avalon: The Resistance'. Regras para papéis: Merlin, Percival, Morgana, Oberon, Mordred",
    keywords: ['Papéis', 'Regras', 'Merlin', 'Percival', 'Morgana', 'Oberon', 'Mordred', 'Dicas'],
  },
  en: {
    title: 'Avalon Roles: Merlin, Percival, Morgana & More',
    description:
      'Explore Avalon roles, their abilities and allegiances. Learn who Merlin and Percival can see, how evil roles work, and which characters to add to your game.',
    keywords: ['Roles', 'Rules', 'Merlin', 'Percival', 'Morgana', 'Oberon', 'Mordred', 'Tips'],
  },
  ru: {
    title: 'Авалон: Сопротивление | Роли',
    description:
      "Все доступные роли в настольной игре 'Авалон: Сопротивление'. Правила для ролей: Мерлин, Персиваль, Моргана, Оберон, Мордред",
    keywords: ['Роли', 'Правила', 'Мерлин', 'Персиваль', 'Моргана', 'Оберон', 'Мордред', 'Советы'],
  },
  'zh-TW': {
    title: '阿瓦隆：反抗勢力 | 角色',
    description: '桌遊『阿瓦隆：反抗勢力』的所有可用角色。角色規則：梅林、派西維爾、莫甘娜、奧伯倫、莫德雷德',
    keywords: ['角色', '規則', '梅林', '派西維爾', '莫甘娜', '奧伯倫', '莫德雷德', '提示'],
  },
  'zh-CN': {
    title: '阿瓦隆：反抗组织 | 角色',
    description: '桌游《阿瓦隆：反抗组织》的所有可用角色。角色规则：梅林、派西维尔、莫甘娜、奥伯伦、莫德雷德',
    keywords: ['角色', '规则', '梅林', '派西维尔', '莫甘娜', '奥伯伦', '莫德雷德', '提示'],
  },
  es: {
    title: 'Avalon: La Resistencia | Roles',
    description:
      "Todos los roles disponibles en el juego de mesa 'Avalon: La Resistencia'. Reglas para los roles: Merlín, Perceval, Morgana, Oberón, Mordred",
    keywords: ['Roles', 'Reglas', 'Merlín', 'Perceval', 'Morgana', 'Oberón', 'Mordred', 'Consejos'],
  },
};
